(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ks-core"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (customElements.get('ks-surface')) return;
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const route = path => `${window.Shopify?.routes?.root || '/'}${path}`;
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const all = (root, selector) => Array.from(root.querySelectorAll(selector));
  const savedKey = 'kirasilv-favorites-v1';
  const readSaved = () => { try { const value = JSON.parse(localStorage.getItem(savedKey) || '[]'); return Array.isArray(value) ? value.filter(x => x && typeof x.id === 'string' && typeof x.url === 'string').slice(0, 60) : []; } catch { return []; } };
  const writeSaved = value => { try { localStorage.setItem(savedKey, JSON.stringify(value)); return true; } catch { return false; } };
  const safeURL = value => { try { const url = new URL(value, location.origin); return ['http:', 'https:'].includes(url.protocol) ? url.href : ''; } catch { return ''; } };
  const closeAll = () => all(document, '.ks dialog[open]').forEach(dialog => dialog.close());
  let lockCount = 0, originalOverflow = '';
  const lock = () => { if (!lockCount++) { originalOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; } };
  const unlock = () => { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.documentElement.style.overflow = originalOverflow; };

  class KSSurface extends HTMLElement {
    connectedCallback() {
      if (this.life) return;
      this.life = new AbortController();
      this.openDialogs = new Set();
      this.on(this, 'click', event => this.handleClick(event));
      this.on(this, 'submit', event => {
        const form = event.target.closest('form[data-ks-add]');
        if (form && form.closest('.ks') === this) { event.preventDefault(); this.add(form); }
      });
      all(this, 'dialog').forEach(dialog => {
        this.on(dialog, 'close', () => {
          if (this.openDialogs.delete(dialog)) unlock();
          const opener = dialog._ksOpener;
          if (opener?.isConnected) opener.focus({ preventScroll: true });
          this.updateSticky?.();
          document.dispatchEvent(new CustomEvent('kirasilv:dialog'));
        });
        this.on(dialog, 'click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      });
      this.on(document, 'kirasilv:cart-updated', event => all(this, '[data-ks-bag-count]').forEach(el => { el.textContent = String(event.detail.count); }));
      all(this, '[data-saved-list]').forEach(el => { el.hidden = !document.querySelector('ks-product [data-dialog="saved"]'); });
      this.on(window, 'storage', event => { if (event.key === savedKey) this.updateSaved?.(); });
      this.on(document, 'shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        event.target.closest('details')?.setAttribute('open', '');
      });
    }
    disconnectedCallback() {
      this.life?.abort(); this.life = null;
      this.variantRequest?.abort(); this.cartRequest?.abort();
      this.galleryObserver?.disconnect(); this.stickyObserver?.disconnect();
      clearTimeout(this.scrollTimer); cancelAnimationFrame(this.frame);
      this.openDialogs?.forEach(() => unlock()); this.openDialogs?.clear();
    }
    on(target, type, handler, options = {}) { target.addEventListener(type, handler, { ...options, signal: this.life.signal }); }
    open(dialog, opener) {
      if (!dialog || dialog.open) return;
      closeAll();
      dialog._ksOpener = opener || document.activeElement;
      dialog.showModal(); this.openDialogs.add(dialog); lock();
      this.updateSticky?.();
      document.dispatchEvent(new CustomEvent('kirasilv:dialog'));
    }
    status(message, root = this) {
      const el = root.querySelector('[data-ks-status]');
      if (el) { el.textContent = message; el.hidden = !message; }
    }
    handleClick(event) {
      const button = event.target.closest('button,a');
      if (!button || button.closest('.ks') !== this) return;
      if (button.hasAttribute('data-close')) { event.preventDefault(); button.closest('dialog')?.close(); }
      else if (button.dataset.open) {
        const dialog = this.querySelector(`[data-dialog="${CSS.escape(button.dataset.open)}"]`);
        if (dialog) { event.preventDefault(); this.open(dialog, button); }
      } else if (button.hasAttribute('data-ks-open-cart')) {
        const cart = document.querySelector('ks-cart');
        if (cart) { event.preventDefault(); cart.refreshAndOpen(button); }
      } else if (button.dataset.ksTarget) {
        const target = document.querySelector(`[data-ks-anchor="${CSS.escape(button.dataset.ksTarget)}"]`);
        if (target) { event.preventDefault(); closeAll(); if (button.dataset.ksTab) target.closest('ks-product')?.activateTab(button.dataset.ksTab); requestAnimationFrame(() => { target.scrollIntoView({ behavior: motion(), block: 'start' }); target.querySelector('a,button,input')?.focus({ preventScroll: true }); }); }
      } else if (button.hasAttribute('data-saved-list')) {
        event.preventDefault(); const main = document.querySelector('ks-product'); main?.showSaved(button);
      }
    }
    async add(form) {
      if (this.adding || this.variantLoading) return;
      if (!form.reportValidity()) return;
      const submit = form.querySelector('[type="submit"]');
      if (!submit || submit.disabled) return;
      this.adding = true;
      const original = submit.innerHTML;
      const payload = new FormData(form);
      const cart = document.querySelector('ks-cart');
      const useDrawer = this.dataset.afterAdd !== 'page' && !!cart;
      if (useDrawer) { payload.set('sections', cart.dataset.sectionId); payload.set('sections_url', location.pathname); }
      submit.disabled = true; form.setAttribute('aria-busy', 'true'); this.status('', form);
      const label = submit.querySelector('[data-button-label]');
      if (label) label.textContent = this.dataset.adding || submit.textContent;
      this.updateSticky?.();
      let confirmed = false;
      try {
        const response = await fetch(route('cart/add.js'), { method: 'POST', body: payload, headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
        confirmed = true;
        if (!useDrawer) { location.assign(route('cart')); return; }
        const markup = result.sections?.[cart.dataset.sectionId];
        if (markup) cart.replaceFrom(markup, true, submit);
        else await cart.refreshAndOpen(submit);
      } catch (error) {
        if (confirmed) { location.assign(route('cart')); return; }
        this.status(error.message || this.dataset.error, form);
        if (form === this.querySelector('form[data-ks-add]')) {
          this.querySelector('[data-ks-status]')?.scrollIntoView({ behavior: motion(), block: 'center' });
        }
      } finally {
        this.adding = false;
        if (submit.isConnected) { submit.innerHTML = original; submit.disabled = this.dataset.available === 'false'; form.removeAttribute('aria-busy'); this.updateSticky?.(); }
      }
    }
  }

  class KSProduct extends KSSurface {
    connectedCallback() {
      if (this.life) return;
      super.connectedCallback();
      this.rail = this.querySelector('[data-gallery]');
      this.slides = this.rail ? all(this.rail, '[data-media-id]') : [];
      this.index = Math.max(0, this.slides.findIndex(el => el.dataset.mediaId === this.dataset.featuredMedia));
      this.lightIndex = this.index; this.swipedAt = 0;
      this.on(this, 'click', event => this.productClick(event));
      this.on(this, 'input', event => { if (event.target.matches('[data-quantity]')) this.updateQuantity(); });
      this.on(this, 'change', event => { if (event.target.matches('[data-plan]')) this.updatePlan(); });
      this.on(document, 'kirasilv:dialog', () => this.updateSticky());
      this.on(this, 'keydown', event => this.keyboard(event));
      if (this.rail) {
        this.on(this.rail, 'scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => { this.index = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.rail.scrollLeft / Math.max(1, this.rail.clientWidth)))); this.galleryMeta(); }, 75);
        }, { passive: true });
        this.on(this.rail, 'pointerdown', e => { this.pointer = { x: e.clientX, y: e.clientY }; }, { passive: true });
        this.on(this.rail, 'pointermove', e => { if (this.pointer && (Math.abs(e.clientX - this.pointer.x) > 12 || Math.abs(e.clientY - this.pointer.y) > 12)) this.swipedAt = performance.now(); }, { passive: true });
        this.on(this.rail, 'pointerup', () => { this.pointer = null; }, { passive: true });
        this.on(this.rail, 'pointercancel', () => { this.pointer = null; this.swipedAt = performance.now(); }, { passive: true });
        this.galleryObserver = new ResizeObserver(() => this.go(this.index, false));
        this.galleryObserver.observe(this.rail);
        requestAnimationFrame(() => { if (this.isConnected) this.go(this.index, false); });
      }
      this.on(window, 'scroll', () => this.scheduleSticky(), { passive: true });
      this.on(window, 'resize', () => this.scheduleSticky(), { passive: true });
      if (window.visualViewport) this.on(window.visualViewport, 'resize', () => this.scheduleSticky(), { passive: true });
      const buy = this.querySelector('[data-add-button]');
      if (buy) { this.stickyObserver = new IntersectionObserver(() => this.updateSticky()); this.stickyObserver.observe(buy); }
      this.activateTab(this.querySelector('[data-info-tab]')?.dataset.infoTab);
      this.updateQuantity(); this.updateSaved(); this.updateSticky(); this.updatePlan();
    }
    productClick(event) {
      const button = event.target.closest('a,button');
      if (!button || button.closest('.ks') !== this) return;
      if (button.hasAttribute('data-option-link') && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault(); if (!this.adding) this.selectOption(button);
      } else if (button.hasAttribute('data-slide')) this.go(Number(button.dataset.slide));
      else if (button.dataset.galleryStep) this.go(this.index + Number(button.dataset.galleryStep));
      else if (button.hasAttribute('data-enlarge')) this.lightbox(this.index, button);
      else if (button.hasAttribute('data-lightbox')) {
        if (performance.now() - this.swipedAt < 400) { event.preventDefault(); return; }
        this.lightbox(Number(button.dataset.lightbox), button);
      } else if (button.dataset.lightboxStep) this.lightbox(this.lightIndex + Number(button.dataset.lightboxStep));
      else if (button.hasAttribute('data-zoom')) this.zoom(button);
      else if (button.dataset.qtyStep) {
        const input = this.querySelector('[data-quantity]');
        if (input) { try { Number(button.dataset.qtyStep) > 0 ? input.stepUp() : input.stepDown(); } catch { input.value = input.min || '1'; } this.updateQuantity(); }
      } else if (button.dataset.infoTab) this.activateTab(button.dataset.infoTab);
      else if (button.dataset.unit) this.units(button.dataset.unit);
      else if (button.hasAttribute('data-save')) this.toggleSaved(button);
      else if (button.hasAttribute('data-mobile-action')) {
        if (button.dataset.action === 'add') this.querySelector('form[data-ks-add]')?.requestSubmit();
        else { this.querySelector('[data-purchase]')?.scrollIntoView({ behavior: motion(), block: 'start' }); this.querySelector('[data-option-link], [data-quantity], [data-add-button]')?.focus({ preventScroll: true }); }
      }
    }
    async selectOption(button) {
      const href = new URL(button.href);
      if (href.pathname !== new URL(this.dataset.productUrl, location.origin).pathname) { location.assign(href); return; }
      this.variantRequest?.abort();
      const request = new AbortController(); this.variantRequest = request;
      href.searchParams.set('section_id', this.dataset.sectionId);
      this.variantLoading = true;
      this.querySelector('[data-purchase]')?.setAttribute('aria-busy', 'true');
      const submit = this.querySelector('[data-add-button]'); if (submit) submit.disabled = true;
      this.updateSticky(); this.status('');
      try {
        const response = await fetch(href, { signal: request.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(this.dataset.variantError);
        const fresh = parse(await response.text()).querySelector('ks-product');
        if (!fresh || fresh.dataset.sectionId !== this.dataset.sectionId) throw new Error(this.dataset.variantError);
        const qty = this.querySelector('[data-quantity]')?.value;
        const focus = { position: button.dataset.optionPosition, id: button.dataset.optionId };
        const quantity = fresh.querySelector('[data-quantity]');
        if (quantity && qty) {
          const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1, max = quantity.max ? Number(quantity.max) : Infinity;
          quantity.value = String(Math.min(max, Math.max(min, min + Math.floor((Number(qty) - min) / step) * step)));
        }
        const nextURL = new URL(location.href);
        nextURL.searchParams.delete('section_id'); nextURL.searchParams.delete('option_values');
        if (fresh.dataset.variantId) nextURL.searchParams.set('variant', fresh.dataset.variantId);
        else { nextURL.searchParams.delete('variant'); nextURL.searchParams.set('option_values', href.searchParams.get('option_values')); }
        if (this.dataset.updateUrl === 'true') history.replaceState({}, '', nextURL);
        this.replaceWith(fresh);
        requestAnimationFrame(() => fresh.querySelector(`[data-option-position="${CSS.escape(focus.position)}"][data-option-id="${CSS.escape(focus.id)}"]`)?.focus({ preventScroll: true }));
      } catch (error) {
        if (error.name !== 'AbortError') this.status(this.dataset.variantError);
      } finally {
        if (this.isConnected && this.variantRequest === request) {
          this.variantLoading = false; this.querySelector('[data-purchase]')?.removeAttribute('aria-busy');
          if (submit) submit.disabled = this.dataset.available !== 'true'; this.updateSticky();
        }
      }
    }
    go(index, smooth = true) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.rail.scrollTo({ left: this.index * this.rail.clientWidth, behavior: smooth ? motion() : 'instant' }); this.galleryMeta();
    }
    galleryMeta() {
      const slide = this.slides[this.index]; if (!slide) return;
      const caption = this.querySelector('[data-gallery-caption]'); if (caption) caption.textContent = slide.dataset.caption;
      const count = this.querySelector('[data-gallery-count]'); if (count) count.textContent = String(this.index + 1).padStart(2, '0');
      all(this, '[data-slide]').forEach(el => el.setAttribute('aria-current', String(Number(el.dataset.slide) === this.index)));
    }
    lightbox(index, opener) {
      if (!this.slides.length) return;
      this.lightIndex = (index + this.slides.length) % this.slides.length;
      const slide = this.slides[this.lightIndex];
      if (slide.hasAttribute('data-size-slide')) { this.open(this.querySelector('[data-dialog="size"]'), opener); return; }
      const source = slide.querySelector('img');
      if (!source) { slide.querySelector('video')?.play().catch(() => {}); return; }
      const dialog = this.querySelector('[data-dialog="lightbox"]');
      const content = dialog?.querySelector('[data-lightbox-content]'); if (!content) return;
      const image = new Image(); image.src = slide.dataset.fullImage || source.currentSrc || source.src; image.alt = source.alt;
      image.width = 1600; image.height = 1600; content.replaceChildren(image);
      dialog.querySelector('[data-lightbox-caption]').textContent = `${this.lightIndex + 1} / ${this.slides.length} · ${slide.dataset.caption || ''}`;
      dialog.querySelector('[data-lightbox-stage]').classList.remove('ks-zoomed');
      dialog.querySelector('[data-zoom]').setAttribute('aria-pressed', 'false');
      if (!dialog.open) this.open(dialog, opener);
    }
    zoom(button) {
      const stage = this.querySelector('[data-lightbox-stage]'); if (!stage) return;
      const active = stage.classList.toggle('ks-zoomed'); button.setAttribute('aria-pressed', String(active));
      requestAnimationFrame(() => stage.scrollTo({ left: active ? (stage.scrollWidth - stage.clientWidth) / 2 : 0, top: active ? (stage.scrollHeight - stage.clientHeight) / 2 : 0, behavior: 'instant' }));
    }
    updateQuantity() {
      const input = this.querySelector('[data-quantity]'); if (!input) return;
      const value = Number(input.value);
      const minus = this.querySelector('[data-qty-step="-1"]'), plus = this.querySelector('[data-qty-step="1"]');
      if (minus) minus.disabled = value <= (Number(input.min) || 1);
      if (plus) plus.disabled = !!input.max && value >= Number(input.max);
    }
    updatePlan() {
      const option = this.querySelector('[data-plan]')?.selectedOptions[0];
      if (!option) return;
      all(this, '[data-main-price], [data-sticky-price]').forEach(el => { el.textContent = option.dataset.price; });
      const compare = this.querySelector('[data-main-compare]');
      if (compare) { compare.hidden = !option.dataset.compare; compare.textContent = option.dataset.compare || ''; }
    }
    activateTab(key, focus = false) {
      if (!key) return;
      all(this, '[data-info-tab]').forEach(el => { const active = el.dataset.infoTab === key; el.setAttribute('aria-selected', String(active)); el.tabIndex = active ? 0 : -1; if (active && focus) el.focus(); });
      all(this, '[data-info-panel]').forEach(el => { el.hidden = el.dataset.infoPanel !== key; });
    }
    units(unit) {
      all(this, '[data-unit]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.unit === unit)));
      all(this, '[data-unit-column]').forEach(el => el.classList.toggle('ks-active-unit', el.dataset.unitColumn === unit));
      all(this, '[data-dim-mm]').forEach(el => { el.textContent = unit === 'in' ? el.dataset.dimIn : el.dataset.dimMm; });
    }
    keyboard(event) {
      const tab = event.target.closest('[data-info-tab]');
      if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        event.preventDefault(); const tabs = all(this, '[data-info-tab]'), current = tabs.indexOf(tab);
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        this.activateTab(tabs[index].dataset.infoTab, true);
      } else if (['ArrowLeft', 'ArrowRight'].includes(event.key) && !event.target.matches('input,select,textarea')) {
        const step = event.key === 'ArrowRight' ? 1 : -1;
        if (this.querySelector('[data-dialog="lightbox"]')?.open) { event.preventDefault(); this.lightbox(this.lightIndex + step); }
        else if (event.target.closest('[data-gallery]')) { event.preventDefault(); this.go(this.index + step); }
      }
    }
    scheduleSticky() { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateSticky(); }); }
    updateSticky() {
      const bar = this.querySelector('[data-mobile-buy]'), buy = this.querySelector('[data-add-button]'); if (!bar || !buy) return;
      const rect = buy.getBoundingClientRect(), offset = Number(this.dataset.headerOffset) || 0;
      const visible = rect.bottom > offset && rect.top < innerHeight - 20;
      bar.hidden = visible || !!document.querySelector('.ks dialog[open]') || innerWidth >= 750;
      const button = bar.querySelector('[data-mobile-action]'), past = rect.bottom <= offset;
      button.dataset.action = past ? 'add' : 'options'; button.disabled = past && (buy.disabled || this.adding || this.variantLoading);
      button.querySelector('[data-button-label]').textContent = past ? (this.dataset.available === 'true' ? this.dataset.addLabel : this.dataset.soldOut) : this.dataset.optionsLabel;
    }
    updateSaved() {
      const saved = readSaved().some(x => x.id === this.dataset.productId), button = this.querySelector('[data-save]');
      if (button) { button.setAttribute('aria-pressed', String(saved)); button.querySelector('span').textContent = saved ? this.dataset.savedLabel : this.dataset.saveLabel; }
    }
    toggleSaved(button) {
      const items = readSaved(), at = items.findIndex(x => x.id === this.dataset.productId);
      if (at >= 0) items.splice(at, 1);
      else items.unshift({ id: this.dataset.productId, title: this.dataset.productTitle, url: this.dataset.productUrl, image: this.querySelector('[data-gallery] img')?.src || '' });
      if (!writeSaved(items.slice(0, 60))) { this.status(this.dataset.saveError); return; }
      this.updateSaved(); if (at < 0) this.showSaved(button);
    }
    showSaved(opener) {
      const dialog = this.querySelector('[data-dialog="saved"]'); if (!dialog) return;
      const items = readSaved(), target = dialog.querySelector('[data-saved-items]');
      target.replaceChildren();
      items.forEach(item => {
        const url = safeURL(item.url); if (!url) return;
        const link = document.createElement('a'); link.className = 'ks-mini-item'; link.href = url;
        if (safeURL(item.image)) { const image = new Image(70, 78); image.src = safeURL(item.image); image.alt = ''; link.append(image); }
        const name = document.createElement('strong'); name.textContent = item.title; link.append(name); target.append(link);
      });
      dialog.querySelector('[data-saved-empty]').hidden = items.length > 0; this.open(dialog, opener);
    }
  }

  class KSRelated extends KSSurface {
    connectedCallback() {
      if (this.life) return; super.connectedCallback();
      this.on(this, 'change', event => {
        if (!event.target.matches('[data-quick-variant]')) return;
        const option = event.target.selectedOptions[0], dialog = event.target.closest('dialog');
        dialog.querySelector('[data-quick-price]').textContent = option.dataset.price;
        const image = dialog.querySelector('[data-quick-image]');
        if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
        const button = dialog.querySelector('[type="submit"]'); button.disabled = option.dataset.available !== 'true';
        button.querySelector('[data-button-label]').textContent = button.disabled ? this.dataset.soldOut : this.dataset.addLabel;
        const qty = dialog.querySelector('input[name="quantity"]'); qty.value = option.dataset.min || '1';
      });
    }
    async add(form) {
      await super.add(form);
      const selected = form.querySelector('[data-quick-variant]')?.selectedOptions[0];
      if (selected && form.isConnected) form.querySelector('[type="submit"]').disabled = selected.dataset.available !== 'true';
    }
  }

  class KSCart extends KSSurface {
    connectedCallback() {
      if (this.life) return; super.connectedCallback();
      this.on(this, 'click', event => {
        const button = event.target.closest('[data-cart-quantity]');
        if (button) { event.preventDefault(); this.change(button.dataset.lineKey, Number(button.dataset.cartQuantity), button); }
      });
      document.dispatchEvent(new CustomEvent('kirasilv:cart-updated', { detail: { count: Number(this.dataset.count) || 0 } }));
    }
    replaceFrom(markup, show = true, opener) {
      if (!this.isConnected) {
        const current = document.querySelector('ks-cart');
        if (current && current !== this) return current.replaceFrom(markup, show, opener);
        throw new Error(this.dataset.error);
      }
      const fresh = parse(markup).querySelector('ks-cart'); if (!fresh) throw new Error(this.dataset.error);
      const oldDialog = this.querySelector('dialog'); if (oldDialog?.open) oldDialog.close();
      this.replaceWith(fresh);
      if (show) fresh.open(fresh.querySelector('dialog'), opener?.isConnected ? opener : document.activeElement);
      return fresh;
    }
    async refreshAndOpen(opener) {
      if (this.refreshing) return;
      this.refreshing = true;
      try {
        const url = new URL(route('cart'), location.origin); url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { headers: { Accept: 'text/html' }, cache: 'no-store' });
        if (!response.ok) throw new Error(this.dataset.error);
        const markup = await response.text();
        if (!this.isConnected) return document.querySelector('ks-cart');
        return this.replaceFrom(markup, true, opener);
      } catch { location.assign(route('cart')); }
      finally { this.refreshing = false; }
    }
    async change(key, quantity, opener) {
      if (this.changing || !Number.isInteger(quantity) || quantity < 0) return;
      this.changing = true; this.status('');
      const dialog = this.querySelector('dialog'); dialog.setAttribute('aria-busy', 'true');
      const buttons = all(this, '[data-cart-quantity], [name="checkout"]'); buttons.forEach(b => { b.dataset.wasDisabled = String(b.disabled); b.disabled = true; });
      try {
        const response = await fetch(route('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: [this.dataset.sectionId], sections_url: location.pathname }) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
        const markup = result.sections?.[this.dataset.sectionId];
        const fresh = markup ? this.replaceFrom(markup, true) : await this.refreshAndOpen();
        const focus = fresh?.querySelector(`[data-line-key="${CSS.escape(key)}"]`) || fresh?.querySelector('[data-close]'); focus?.focus({ preventScroll: true });
      } catch (error) { this.status(error.message || this.dataset.error); }
      finally {
        this.changing = false;
        if (this.isConnected) { dialog.removeAttribute('aria-busy'); buttons.forEach(b => { b.disabled = b.dataset.wasDisabled === 'true'; }); opener?.focus({ preventScroll: true }); }
      }
    }
  }
  customElements.define('ks-surface', KSSurface);
  customElements.define('ks-product', KSProduct);
  customElements.define('ks-related', KSRelated);
  customElements.define('ks-cart', KSCart);
})();
  } catch(e) { console.error(e); }
})();

})();
